import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import {
    getIsBitSet,
    type ListViewBitFlagsMasks,
} from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { PersonaCheckboxDisplayOption } from '../store/schema/PersonaCheckboxDisplayOption';

// Convert the legacy HideSenderImage bit to a PersonaCheckboxDisplayOption; used as OCS fallback.
export default function getLegacyPersonaCheckboxDisplay(): PersonaCheckboxDisplayOption {
    const hideSenderImage = getIsBitSet(8, getGlobalSettingsAccountMailboxInfo());
    return hideSenderImage
        ? PersonaCheckboxDisplayOption.ShowCheckboxOnly
        : PersonaCheckboxDisplayOption.ShowSenderImage;
}
